export const Header = () => {
    return (
        <div className="header">
            <div className="logo">
                <img src="logo.png" alt="Gambling-List.com" />
            </div>
            <h1>Gambling-List.com</h1>
        </div>
    );
};